"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderWrapper = exports.IconWrapper = exports.Label = exports.IconButtonStyle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.IconButtonStyle = styled_components_1.default.div `
    white-space: nowrap;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    min-width: min-content;
    font-weight: 700;
    color: ${colors_1.WHITE};
    background-color: ${({ $color }) => ($color ? $color : colors_1.DARK_GREEN)};
    &:hover {
      filter: brightness(120%)
    }
    border: ${({ $noBorder }) => ($noBorder ? "0px" : `1px solid ${colors_1.DARK_GREEN}`)};
    text-transform: uppercase;
    box-sizing: border-box;
    ${(props) => props.$disabled &&
    (0, styled_components_1.css) `
        color: ${colors_1.LIGHT_GREY};
        background-color: ${colors_1.WHITE};
        border: 1px solid ${colors_1.LIGHT_GREY};
        cursor: auto;
      `}
    ${(props) => props.$disabled &&
    props.$isRUD &&
    (0, styled_components_1.css) `
        color: ${colors_1.GREY2};
        background-color: ${colors_1.GREY4};
        border: 1px solid ${colors_1.GREY2};
        cursor: auto;
      `}

    ${(props) => !props.$disabled &&
    !props.$color &&
    (0, styled_components_1.css) `
        &:focus {
          opacity: 0.9;
        }
        &:hover {
          cursor: pointer;
          border: 1px solid ${colors_1.SWEGON_GREEN};
          background-color: ${colors_1.SWEGON_GREEN};
        }
        &:active {
          opacity: 0.7;
        }
      `}
`;
exports.Label = styled_components_1.default.span `
  margin: 0 16px;
  &:hover {
    ${(props) => !props.$disabled &&
    (0, styled_components_1.css) `
        cursor: pointer;
      `};
  }
  ${(props) => props.$disabled &&
    (0, styled_components_1.css) `
      cursor: default;
    `}
`;
exports.IconWrapper = styled_components_1.default.div `
  display: flex;
  margin: 0 16px;
`;
exports.LoaderWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
//# sourceMappingURL=IconButton.styles.js.map